import { Button, styled } from '@teko/ds-mobile';
import DOMPurify from 'dompurify';
import { t } from 'i18n';

type OutstandingFeaturesProps = {
  features: string;
  onViewDetail: () => void;
};

export const OutstandingFeatures: React.FC<OutstandingFeaturesProps> = ({
  features,
  onViewDetail,
}) => {
  return (
    <StyledWrapper>
      <StyledHeader>
        <StyledTitle>{t('Đặc điểm nổi bật')}</StyledTitle>
        <Button variant="link" onClick={onViewDetail}>
          {t('Xem thông tin chi tiết')}
        </Button>
      </StyledHeader>
      <StyledContent
        dangerouslySetInnerHTML={{ __html: DOMPurify?.sanitize?.(features) }}
      />
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
  border-radius: ${({ theme }) => theme.borderRadius.m};
  padding: ${({ theme }) => theme.spacing.s8};
`;

const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.spacing.s8};
`;

const StyledTitle = styled.span`
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.textTitle};
`;

const StyledContent = styled.div`
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  overflow: hidden;
  color: ${({ theme }) => theme.colors.textPrimary};
`;
